export default {
  'phoneSource.systemUser': '(Utilisateur système)',
  'phoneSource.account': '(Compte)',
  'phoneSource.contact': '(Contact)',
  'phoneSource.lead': '(Piste)',
  'phoneType.phone': '(Téléphone)',
  'phoneType.home': '(Téléphone domicile)',
  'phoneType.business': '(Téléphone bureau)',
  'phoneType.mobile': '(Téléphone mobile)',
  'phoneType.unknown': '(Type de téléphone inconnu)',
  'phoneType.extension': '(Téléphone d\'extension)',
};
